import { AutoComplete, useFormContext } from "@4uhub/lib4uhub";
import { Alert, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { TTicketServiceAreaForm } from "./TicketServiceAreaSchema";

const translationPath = "chatBot.page.service.ticketServiceArea.";

interface ITicketServiceFieldProps {
  request: (params?: any) => Promise<any>;
}

export const TicketServiceField = ({ request }: ITicketServiceFieldProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<TTicketServiceAreaForm>();

  const ticketService = useWatch({
    name: "ticketService",
    control,
  });

  const hasExternalChat = Boolean(ticketService?.externalChatSiteAppId);
  const siteAppName =
    ticketService?.externalChatSiteApp?.name ||
    (ticketService as any)?.externalChatSiteAppName ||
    "";

  return (
    <>
      <Grid item xs={12} sm={6}>
        <AutoComplete
          getOptionLabel={(option) => {
            return option.name;
          }}
          size="small"
          label={t(translationPath + "ticket_services")}
          name="ticketService"
          request={request}
        />
      </Grid>

      {hasExternalChat && (
        <Grid item xs={12}>
          <Alert severity="warning">
            {t(translationPath + "automatic_external_chat_alert", {
              defaultValue: `Esse serviço de tickets tem um direcionamento automático ativado para o chat interno (4uChat) do Site "${siteAppName}"`,
              siteAppName,
            })}
          </Alert>
        </Grid>
      )}
    </>
  );
};
